import { render } from "./TaskDetailDrawer.vue?vue&type=template&id=fc7f37f4&scoped=true"
import script from "./TaskDetailDrawer.vue?vue&type=script&lang=js"
export * from "./TaskDetailDrawer.vue?vue&type=script&lang=js"

import "./TaskDetailDrawer.vue?vue&type=style&index=0&id=fc7f37f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc7f37f4"]])

export default __exports__